import { render, staticRenderFns } from "./SidebarFooter.vue?vue&type=template&id=de7b876c"
import script from "./SidebarFooter.vue?vue&type=script&lang=js"
export * from "./SidebarFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports